import React, { useState } from "react";
import "../../styles/atoms.scss"; // Ensure styles are applied
import SvgIcn from "../../data/IconCompo";

const Popupz = ({ title, iconIllus, icon, text, children, onClose, popupId, className }) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => {
    setIsOpen(false);
    if (onClose) onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay" id={popupId}>
      <div className={`popup-container ${className || ''}`}>

        <div className="close-button" onClick={handleClose}>
          <SvgIcn name="close" />
        </div>
        
        <div className="popup-content">
          {title && <span className="popup-title">{title}</span>}
          {icon && (
            <div className="popup-icon">
              <SvgIcn name={icon} />
            </div>
          )}
          {text && <div className="popup-text">{text}</div>}
          {children}
        </div>

        {iconIllus && (
          <div className="popup-leftside">
            <SvgIcn name={iconIllus} />
          </div>
        )}

      </div>
    </div>
  );
};

export default Popupz;
